{
  "name": "HS 55°-110°: harmonic partial row from 55° to 110°",
  "description": "A 55-tone one octave cycle comprising the harmonic partial row from 55° to 110°. 27° (Degree 53) is tuned to A 440 Hz, so the fundamental pitch-class (1°, 2°, 4°, 8°, 16°, etc.) is Pythagorean C. The Central Degree is 9 (1°). The entire series may be transposed to any fundamental by changing the Reference Frequency and Degree.",
  "scale": [
    "56/55",
    "57/55",
    "58/55",
    "59/55",
    "60/55",
    "61/55",
    "62/55",
    "63/55",
    "64/55",
    "65/55",
    "66/55",
    "67/55",
    "68/55",
    "69/55",
    "70/55",
    "71/55",
    "72/55",
    "73/55",
    "74/55",
    "75/55",
    "76/55",
    "77/55",
    "78/55",
    "79/55",
    "80/55",
    "81/55",
    "82/55",
    "83/55",
    "84/55",
    "85/55",
    "86/55",
    "87/55",
    "88/55",
    "89/55",
    "90/55",
    "91/55",
    "92/55",
    "93/55",
    "94/55",
    "95/55",
    "96/55",
    "97/55",
    "98/55",
    "99/55",
    "100/55",
    "101/55",
    "102/55",
    "103/55",
    "104/55",
    "105/55",
    "106/55",
    "107/55",
    "108/55",
    "109/55",
    "110/55"
  ],
  "key_colors_mode": "manual",
  "short_description": "55-HS_55to110",
  "built_in_group": "Harmonics and Subharmonics",
  "key_labels": "note_names",
  "note_names": [
    "55°",
    "7",
    "57",
    "29",
    "59",
    "15",
    "61",
    "31",
    "63",
    "1",
    "65",
    "33",
    "67",
    "17",
    "69",
    "35",
    "71",
    "9",
    "73",
    "37",
    "75",
    "19",
    "77",
    "39",
    "79",
    "5",
    "81",
    "41",
    "83",
    "21",
    "85",
    "43",
    "87",
    "11",
    "89",
    "45",
    "91",
    "23",
    "93",
    "47",
    "95",
    "3",
    "97",
    "49",
    "99",
    "25",
    "101",
    "51",
    "103",
    "13",
    "105",
    "53",
    "107",
    "27",
    "109",
    "55"
  ],
  "note_colors": [
    "#ff8d8d",
    "#ffe5e5",
    "#d6f7ff",
    "#b6ece3",
    "#e5adff",
    "#fffae5",
    "#ededed",
    "#68f3ec",
    "#ffe5e5",
    "#ffffff",
    "#e9d7d3",
    "#dfffd6",
    "#ededed",
    "#cfcfcf",
    "#95c69b",
    "#ffcba8",
    "#ededed",
    "#ffffff",
    "#ededed",
    "#cee3e2",
    "#fef5be",
    "#d6f7ff",
    "#e9ecc1",
    "#e6d7fe",
    "#ededed",
    "#fffae5",
    "#ffffff",
    "#d39e92",
    "#ededed",
    "#ffe5e5",
    "#eceae4",
    "#dee2da",
    "#8aafff",
    "#dfffd6",
    "#ededed",
    "#fffae5",
    "#ebd0e0",
    "#95c69b",
    "#68f3ec",
    "#ffb8da",
    "#e5fff9",
    "#ffffff",
    "#ededed",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be",
    "#ededed",
    "#cfcfcf",
    "#ededed",
    "#e6d7fe",
    "#ffcba8",
    "#ededed",
    "#ededed",
    "#ffffff",
    "#ededed",
    "#ddfe95"
  ],
  "equivSteps": 55,
  "fundamental": 440,
  "reference_degree": 53,
  "center_degree": 9,
  "rSteps": 8,
  "drSteps": 5,
  "hexSize": 32,
  "rotation": -8.2,
  "lumatone_anchor_note": 5,
  "lumatone_anchor_channel": 2
}
